/**
 * @desc 创建bom供应链申请外发审批提交表单
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<string>;
export function request(
  body: defs.basics.PlmBomOutCreateRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/bom/outgoing/formSupplySubmit`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
